var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9333,
    y: 9.93164,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1865,
    y: 9.93164,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4399,
    y: 9.93164,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9333,
    y: 15.1849,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1865,
    y: 15.1849,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4399,
    y: 15.1849,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9333,
    y: 20.4382,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1865,
    y: 20.4382,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4399,
    y: 20.4382,
    width: 2.62664,
    height: 2.62664,
    rx: 1.31332,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 6.5,
    stroke: "#CFCFCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.77dbf57868f1edfd183c027ac5e39692.svg";
export { ForwardRef as ReactComponent };